import { observer } from 'mobx-react-lite'
import { RemoveDependentDialog } from './index'
import type { DependentsInfoRequestedSupportingItemViewModel } from '@/features/jobs/details/tax-type/info-gathering/dependents-info/DependentsInfoRequestedSupportingItemViewModel'
import { formatFullName } from '@/utils/full-name-util'

export interface RemoveDependentDialogContainerProps {
  vm: DependentsInfoRequestedSupportingItemViewModel
}

/**
 * Container for the RemoveDependentDialog that wires up the view model.
 */
export const RemoveDependentDialogContainer = observer(
  function RemoveDependentDialogContainer({
    vm,
  }: RemoveDependentDialogContainerProps) {
    const dependent = vm.dependentBeingRemoved
    const fullName = dependent
      ? formatFullName(
          dependent.personalInfo.firstName,
          dependent.personalInfo.middleInitial,
          dependent.personalInfo.lastName,
        )
      : ''

    return (
      <RemoveDependentDialog
        isOpen={vm.removeDialog.showing}
        onClose={vm.removeDialog.close}
        fullName={fullName}
        isRemovePending={vm.removeDependentFromJob.pending}
        isDeletePending={vm.promptDeleteDependentPermanently.pending}
        onRemovePress={() =>
          vm.dependentBeingRemoved &&
          vm.removeDependentFromJob(vm.dependentBeingRemoved.id)
        }
        onDeletePress={() =>
          vm.dependentBeingRemoved &&
          vm.promptDeleteDependentPermanently(vm.dependentBeingRemoved)
        }
        testId="remove-dependent-dialog"
        removeTestId="remove-dependent-dialog-remove-button"
        deleteTestId="remove-dependent-dialog-delete-button"
        cancelTestId="remove-dependent-dialog-cancel-button"
      />
    )
  },
)
